const Video = () => import('@/views/main/fubo/video/Video.vue')
export default {
  path: '/main/fubo/video',
  name: 'Video',
  component: Video,
  children: []
}
